import React, { useEffect } from 'react';
import { COMPANY, LEGAL_DOCUMENTS, LegalDocument } from './legalDocuments';
import './legal.css';

interface LegalPageProps {
  document: LegalDocument;
  brandName: string;
}

/**
 * Página legal. El cuerpo es HTML estático generado en build desde el repo
 * reserva-ya (ver legalDocuments.ts): no hay ninguna entrada de usuario en él,
 * por eso se inyecta directamente en vez de reconstruirlo como JSX.
 */
const LegalPage: React.FC<LegalPageProps> = ({ document: doc, brandName }) => {
  useEffect(() => {
    window.document.title = `${doc.title} | ${brandName}`;
  }, [doc.title, brandName]);

  const otherDocs = LEGAL_DOCUMENTS.filter(d => d.slug !== doc.slug);

  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <a className="legal-page__brand" href="/">
          {brandName}
        </a>
        <a className="legal-page__back" href="/">
          Volver al inicio
        </a>
      </header>

      <main className="legal-page__container">
        <h1>{doc.title}</h1>
        <p className="legal-page__updated">Última revisión: {doc.updatedAt}</p>

        {/* eslint-disable-next-line react/no-danger */}
        <div
          className="legal-body"
          dangerouslySetInnerHTML={{ __html: doc.html }}
        />

        <hr className="legal-page__rule" />

        <footer className="legal-page__footer">
          <p>
            {COMPANY.name} — CIF {COMPANY.cif} — {COMPANY.address}
          </p>
          <nav>
            {otherDocs.map(d => (
              <a key={d.slug} href={`/${d.slug}`}>
                {d.title}
              </a>
            ))}
            <button type="button" data-cc="show-preferencesModal">
              Configurar cookies
            </button>
          </nav>
        </footer>
      </main>
    </div>
  );
};

export default LegalPage;
